import { render, staticRenderFns } from "./CurriculumSUnitsClassCategories.vue?vue&type=template&id=df493ddc&scoped=true&lang=pug&"
import script from "./CurriculumSUnitsClassCategories.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSUnitsClassCategories.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSUnitsClassCategories.vue?vue&type=style&index=0&id=df493ddc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df493ddc",
  null
  
)

export default component.exports